import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import FluidSpacer, { FluidSpacerProps } from '@/components/base/fluid-spacer'
import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

const spacerVariants = cva(['border-0 bg-transparent'], {
  variants: {
    variant: {
      xxs: 'pt-s-spacer-xxs md:pt-d-spacer-xxs',
      xs: 'pt-s-spacer-xs md:pt-d-spacer-xs',
      sm: 'pt-s-spacer-sm md:pt-d-spacer-sm',
      md: 'pt-s-spacer-md md:pt-d-spacer-md',
      lg: 'pt-s-spacer-lg md:pt-d-spacer-lg',
      xl: 'pt-s-spacer-xl md:pt-d-spacer-xl',
      xxl: 'pt-s-spacer-2xl md:pt-d-spacer-2xl'
    }
  },
  defaultVariants: {
    variant: 'xl'
  }
})

export type SpacerProps = HTMLAttributes<HTMLHRElement> &
  VariantProps<typeof spacerVariants> & {
    is_liquid?: boolean
    orientation?: FluidSpacerProps['variant']
  }

const Spacer = ({
  className,
  is_liquid,
  variant,
  orientation,
  ...props
}: SpacerProps) => {
  return (
    <>
      {is_liquid ? (
        <FluidSpacer variant={orientation} />
      ) : (
        <Section
          asChild
          className={cn(spacerVariants({ variant, className }))}
          {...props}
        >
          <hr />
        </Section>
      )}
    </>
  )
}

export default Spacer
